import { isFulfilled } from '@reduxjs/toolkit'
import type { Middleware, MiddlewareAPI } from '@reduxjs/toolkit'

import Mixpanel from '@Utils/mixpanel/Mixpanel'

import { type baseApi } from '../api'
import { setTokens, unsetTokens } from '../slices/authSlice'

export const setUserMiddleware: (api: typeof baseApi) => Middleware =
  (api: typeof baseApi) =>
  ({ getState }: MiddlewareAPI) =>
  (next: any) =>
  (action: any) => {
    switch (true) {
      // check if setToken dispatched and user is_login_as
      case action?.type === setTokens.type: {
        const { is_login_as = false } = action?.payload?.hasOwnProperty(
          'is_login_as',
        )
          ? action.payload.is_login_as
          : getState().auth

        if (is_login_as === true) {
          break
        }

        const result = api.endpoints.me.select()(getState())
        const { data, isSuccess } = result

        if (isSuccess && data) {
          Mixpanel.setUser({
            id: data.id,
            name: data.name,
            email: data.email,
            status: data.status,
          })
        }
        break
      }
      // check if logged in and fetched /me with is_login_as
      case isFulfilled(action) && action.meta?.arg?.endpointName === 'me': {
        const { is_login_as = false } = getState().auth
        const { id, name, email, status } = action.payload

        if (is_login_as !== true) {
          Mixpanel.setUser({ id, name, email, status })
        }
        break
      }
      // check if unsetToken dispatched
      case action?.type === unsetTokens.type: {
        const { is_login_as = false } = getState().auth

        if (is_login_as !== true) {
          Mixpanel.reset()
        }
        break
      }
      default:
        break
    }
    return next(action)
  }
